import React, { useState } from "react";

const LazyImage = ({ src, alt, className = "" }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <img
            src={src}
            alt={alt}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`
                transition duration-700 ease-in-out
                ${loaded ? "blur-0" : "blur-md scale-105 brightness-90"}
                ${className}
            `}
        />
    );
};

export default LazyImage;
